import { useState, useEffect } from "react";

const PLANS = [
  { id: "starter", name: "Starter", price: 299, priceId: "price_starter_monthly", features: ["15 keywords monitorizadas", "10 acciones off-page / mes", "Dashboard básico", "Informe mensual", "Soporte email", "Sin permanencia"], color: "#64748b", icon: "🚀" },
  { id: "growth", name: "Growth", price: 599, priceId: "price_growth_monthly", popular: true, features: ["37+ keywords monitorizadas", "25+ acciones off-page / mes", "Dashboard completo con pruebas", "Análisis estratégico mensual", "Contenido blog + distribución", "Soporte prioritario", "Sin permanencia"], color: "#3b82f6", icon: "⚡" },
  { id: "agency", name: "Agency", price: 999, priceId: "price_agency_monthly", features: ["Keywords ilimitadas", "50+ acciones off-page / mes", "Dashboard multi-cliente", "Panel admin completo", "White-label personalizable", "Account manager dedicado", "Sin permanencia"], color: "#8b5cf6", icon: "🏢" },
];

const CRD = { background: "rgba(255,255,255,0.02)", borderRadius: 14, border: "1px solid rgba(59,130,246,0.07)" };

export default function StripeCheckout() {
  const [view, setView] = useState("plans"); // plans | checkout | processing | success | manage
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [formData, setFormData] = useState({ name: "", email: "", company: "", website: "", cardNumber: "", expiry: "", cvc: "", country: "ES" });
  const [errors, setErrors] = useState({});
  const [processing, setProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [toast, setToast] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [showCancel, setShowCancel] = useState(false);

  const fire = m => { setToast(m); setTimeout(() => setToast(null), 3500); };

  // Format card number with spaces
  const formatCard = v => {
    const nums = v.replace(/\D/g, "").slice(0, 16);
    return nums.replace(/(\d{4})(?=\d)/g, "$1 ");
  };
  const formatExpiry = v => {
    const nums = v.replace(/\D/g, "").slice(0, 4);
    if (nums.length > 2) return nums.slice(0, 2) + " / " + nums.slice(2);
    return nums;
  };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = "Nombre requerido";
    if (!formData.email.includes("@")) e.email = "Email no válido";
    if (!formData.company.trim()) e.company = "Empresa requerida";
    const cardNums = formData.cardNumber.replace(/\s/g, "");
    if (cardNums.length < 16) e.cardNumber = "Número de tarjeta incompleto";
    const expNums = formData.expiry.replace(/\D/g, "");
    if (expNums.length < 4) e.expiry = "Fecha no válida";
    if (formData.cvc.length < 3) e.cvc = "CVC no válido";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleCheckout = () => {
    if (!validate()) return;
    setView("processing");
    setProgress(0);

    const steps = [
      { p: 15, t: 800 }, { p: 35, t: 600 }, { p: 55, t: 700 },
      { p: 75, t: 500 }, { p: 90, t: 600 }, { p: 100, t: 400 },
    ];

    let delay = 0;
    steps.forEach(step => {
      delay += step.t;
      setTimeout(() => setProgress(step.p), delay);
    });

    setTimeout(() => {
      const sub = {
        id: "sub_" + Math.random().toString(36).slice(2, 10),
        plan: selectedPlan,
        status: "active",
        customer: { name: formData.name, email: formData.email, company: formData.company },
        currentPeriodStart: new Date().toLocaleDateString("es", { day: "2-digit", month: "short", year: "numeric" }),
        currentPeriodEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString("es", { day: "2-digit", month: "short", year: "numeric" }),
        card: { last4: formData.cardNumber.replace(/\s/g, "").slice(-4), brand: formData.cardNumber.startsWith("4") ? "Visa" : "Mastercard" },
        invoices: [
          { id: "inv_001", date: new Date().toLocaleDateString("es"), amount: selectedPlan.price, status: "paid" },
        ],
      };
      setSubscription(sub);
      setView("success");
    }, delay + 800);
  };

  const iS = { width: "100%", padding: "12px 14px", borderRadius: 10, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", color: "#e2e8f0", fontSize: 14, outline: "none", boxSizing: "border-box", transition: "border 0.2s" };
  const lS = { fontSize: 11, fontWeight: 600, color: "#94a3b8", display: "block", marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.8 };

  return (
    <div style={{ fontFamily: "'Sora',sans-serif", background: "#030712", color: "#e2e8f0", minHeight: "100vh", position: "relative", overflow: "hidden" }}>
      <link href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        @keyframes float1{0%,100%{transform:translate(0,0)}50%{transform:translate(20px,-15px)}}
        @keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        @keyframes check{0%{stroke-dashoffset:100}100%{stroke-dashoffset:0}}
        @keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
        .ci:focus{border-color:rgba(59,130,246,0.4)!important;box-shadow:0 0 0 3px rgba(59,130,246,0.08)!important}
        .ph:hover{transform:translateY(-3px)!important;box-shadow:0 12px 40px rgba(59,130,246,0.12)!important}
      `}</style>

      {/* BG orbs */}
      <div style={{ position: "fixed", top: "5%", left: "10%", width: 400, height: 400, borderRadius: "50%", background: "radial-gradient(circle,rgba(59,130,246,0.06) 0%,transparent 65%)", filter: "blur(50px)", animation: "float1 18s ease infinite" }} />
      <div style={{ position: "fixed", bottom: "10%", right: "10%", width: 300, height: 300, borderRadius: "50%", background: "radial-gradient(circle,rgba(139,92,246,0.05) 0%,transparent 65%)", filter: "blur(40px)", animation: "float1 14s ease infinite 4s" }} />

      {toast && <div style={{ position: "fixed", top: 16, right: 16, zIndex: 300, background: "rgba(34,197,94,0.12)", border: "1px solid rgba(34,197,94,0.2)", color: "#22c55e", padding: "10px 20px", borderRadius: 10, fontSize: 13, fontWeight: 600, boxShadow: "0 6px 20px rgba(0,0,0,0.4)", backdropFilter: "blur(6px)" }}>{toast}</div>}

      {/* NAV */}
      <nav style={{ background: "rgba(3,7,18,0.9)", backdropFilter: "blur(14px)", borderBottom: "1px solid rgba(59,130,246,0.06)", padding: "0 24px", position: "sticky", top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: 56 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }} onClick={() => { setView("plans"); setSelectedPlan(null); }}>
            <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg,#3b82f6,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 11, boxShadow: "0 0 14px rgba(59,130,246,0.2)" }}>SF</div>
            <span style={{ fontWeight: 800, fontSize: 15 }}>SEO <span style={{ color: "#3b82f6" }}>Flor</span></span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {subscription && <button onClick={() => setView("manage")} style={{ padding: "6px 14px", borderRadius: 7, background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.12)", color: "#60a5fa", fontSize: 11, fontWeight: 600, cursor: "pointer" }}>💳 Mi suscripción</button>}
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span style={{ fontSize: 10, color: "#22c55e", fontWeight: 600 }}>Pago seguro SSL</span>
            </div>
          </div>
        </div>
      </nav>

      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "32px 24px", position: "relative", zIndex: 1 }}>

        {/* ═══ PLAN SELECTION ═══ */}
        {view === "plans" && <>
          <div style={{ textAlign: "center", marginBottom: 36 }}>
            <div style={{ color: "#3b82f6", fontSize: 11, fontWeight: 700, letterSpacing: 2, marginBottom: 8 }}>ELIGE TU PLAN</div>
            <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: -1.5, marginBottom: 8 }}>Empieza a <span style={{ background: "linear-gradient(135deg,#3b82f6,#8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>dominar Google</span></h1>
            <p style={{ fontSize: 15, color: "#64748b" }}>Todos los planes incluyen dashboard + trabajo SEO + transparencia total</p>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, alignItems: "start" }}>
            {PLANS.map((plan, i) => (
              <div key={i} className="ph" style={{
                ...CRD, padding: plan.popular ? 30 : 26, position: "relative", cursor: "pointer",
                transform: plan.popular ? "scale(1.03)" : "scale(1)", transition: "all 0.25s",
                borderColor: plan.popular ? "rgba(59,130,246,0.25)" : "rgba(255,255,255,0.05)",
                background: plan.popular ? "linear-gradient(135deg,rgba(59,130,246,0.06),rgba(139,92,246,0.03))" : "rgba(255,255,255,0.02)",
                boxShadow: plan.popular ? "0 8px 30px rgba(59,130,246,0.08)" : "none",
              }} onClick={() => { setSelectedPlan(plan); setView("checkout"); }}>
                {plan.popular && <div style={{ position: "absolute", top: -11, left: "50%", transform: "translateX(-50%)", background: "linear-gradient(135deg,#3b82f6,#8b5cf6)", color: "#fff", padding: "4px 16px", borderRadius: 16, fontSize: 10, fontWeight: 700, boxShadow: "0 4px 14px rgba(59,130,246,0.3)", whiteSpace: "nowrap" }}>⚡ Más popular</div>}
                <div style={{ fontSize: 24, marginBottom: 8 }}>{plan.icon}</div>
                <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 2 }}>{plan.name}</div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 3, marginBottom: 16 }}>
                  <span style={{ fontSize: 12, color: "#64748b" }}>€</span>
                  <span style={{ fontSize: 42, fontWeight: 800, background: `linear-gradient(135deg,${plan.color},${plan.color}aa)`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", lineHeight: 1, letterSpacing: -2 }}>{plan.price}</span>
                  <span style={{ fontSize: 14, color: "#64748b" }}>/mes</span>
                </div>
                {plan.features.map((f, fi) => (
                  <div key={fi} style={{ display: "flex", alignItems: "flex-start", gap: 7, marginBottom: 7, fontSize: 13 }}>
                    <span style={{ color: plan.color, fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span><span style={{ color: "#cbd5e1" }}>{f}</span>
                  </div>
                ))}
                <button style={{
                  width: "100%", padding: "12px 0", borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: "pointer", marginTop: 14, transition: "all 0.2s",
                  background: plan.popular ? "linear-gradient(135deg,#3b82f6,#2563eb)" : "rgba(255,255,255,0.04)",
                  color: plan.popular ? "#fff" : "#e2e8f0",
                  border: plan.popular ? "none" : "1px solid rgba(255,255,255,0.08)",
                  boxShadow: plan.popular ? "0 4px 16px rgba(59,130,246,0.25)" : "none",
                }}>Elegir {plan.name} →</button>
              </div>
            ))}
          </div>

          <div style={{ display: "flex", justifyContent: "center", gap: 24, marginTop: 28 }}>
            {["🔒 Pago seguro con Stripe", "🚫 Sin permanencia", "💳 Cancela cuando quieras"].map((t, i) => (
              <span key={i} style={{ fontSize: 12, color: "#475569" }}>{t}</span>
            ))}
          </div>
        </>}

        {/* ═══ CHECKOUT FORM ═══ */}
        {view === "checkout" && selectedPlan && <>
          <button onClick={() => { setView("plans"); setErrors({}); }} style={{ background: "none", border: "none", color: "#60a5fa", cursor: "pointer", fontSize: 12, fontWeight: 600, padding: 0, marginBottom: 16 }}>← Volver a planes</button>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 380px", gap: 20 }}>
            {/* Form */}
            <div style={{ ...CRD, padding: 28 }}>
              <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>Completar suscripción</h2>
              <p style={{ fontSize: 12, color: "#64748b", marginBottom: 20 }}>Introduce tus datos para activar el plan {selectedPlan.name}</p>

              {/* Business info */}
              <div style={{ background: "rgba(59,130,246,0.03)", borderRadius: 10, padding: 16, marginBottom: 18, border: "1px solid rgba(59,130,246,0.06)" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#60a5fa", marginBottom: 10 }}>🏢 Datos del negocio</div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
                  <div>
                    <div style={lS}>Nombre completo *</div>
                    <input className="ci" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="Tu nombre" style={{ ...iS, borderColor: errors.name ? "rgba(239,68,68,0.4)" : undefined }} />
                    {errors.name && <span style={{ fontSize: 10, color: "#ef4444", marginTop: 2, display: "block" }}>{errors.name}</span>}
                  </div>
                  <div>
                    <div style={lS}>Email *</div>
                    <input className="ci" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} placeholder="tu@email.com" style={{ ...iS, borderColor: errors.email ? "rgba(239,68,68,0.4)" : undefined }} />
                    {errors.email && <span style={{ fontSize: 10, color: "#ef4444", marginTop: 2, display: "block" }}>{errors.email}</span>}
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                  <div>
                    <div style={lS}>Empresa *</div>
                    <input className="ci" value={formData.company} onChange={e => setFormData({ ...formData, company: e.target.value })} placeholder="Nombre del negocio" style={{ ...iS, borderColor: errors.company ? "rgba(239,68,68,0.4)" : undefined }} />
                    {errors.company && <span style={{ fontSize: 10, color: "#ef4444", marginTop: 2, display: "block" }}>{errors.company}</span>}
                  </div>
                  <div>
                    <div style={lS}>Website</div>
                    <input className="ci" value={formData.website} onChange={e => setFormData({ ...formData, website: e.target.value })} placeholder="tuweb.com (opcional)" style={iS} />
                  </div>
                </div>
              </div>

              {/* Payment info */}
              <div style={{ background: "rgba(34,197,94,0.03)", borderRadius: 10, padding: 16, marginBottom: 18, border: "1px solid rgba(34,197,94,0.06)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#22c55e" }}>💳 Datos de pago</div>
                  <div style={{ display: "flex", gap: 6 }}>
                    {["Visa", "MC", "Amex"].map((c, i) => (
                      <span key={i} style={{ padding: "2px 8px", borderRadius: 4, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.06)", fontSize: 9, fontWeight: 700, color: "#94a3b8" }}>{c}</span>
                    ))}
                  </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <div style={lS}>Número de tarjeta *</div>
                  <div style={{ position: "relative" }}>
                    <input className="ci" value={formData.cardNumber} onChange={e => setFormData({ ...formData, cardNumber: formatCard(e.target.value) })} placeholder="4242 4242 4242 4242" maxLength={19} style={{ ...iS, paddingLeft: 40, fontFamily: "monospace", letterSpacing: 1, borderColor: errors.cardNumber ? "rgba(239,68,68,0.4)" : undefined }} />
                    <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>
                      {formData.cardNumber.startsWith("4") ? "💳" : formData.cardNumber.startsWith("5") ? "💳" : "💳"}
                    </span>
                  </div>
                  {errors.cardNumber && <span style={{ fontSize: 10, color: "#ef4444", marginTop: 2, display: "block" }}>{errors.cardNumber}</span>}
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
                  <div>
                    <div style={lS}>Expiración *</div>
                    <input className="ci" value={formData.expiry} onChange={e => setFormData({ ...formData, expiry: formatExpiry(e.target.value) })} placeholder="MM / YY" maxLength={7} style={{ ...iS, fontFamily: "monospace", borderColor: errors.expiry ? "rgba(239,68,68,0.4)" : undefined }} />
                    {errors.expiry && <span style={{ fontSize: 10, color: "#ef4444" }}>{errors.expiry}</span>}
                  </div>
                  <div>
                    <div style={lS}>CVC *</div>
                    <input className="ci" type="password" value={formData.cvc} onChange={e => setFormData({ ...formData, cvc: e.target.value.replace(/\D/g, "").slice(0, 4) })} placeholder="•••" maxLength={4} style={{ ...iS, fontFamily: "monospace", borderColor: errors.cvc ? "rgba(239,68,68,0.4)" : undefined }} />
                    {errors.cvc && <span style={{ fontSize: 10, color: "#ef4444" }}>{errors.cvc}</span>}
                  </div>
                  <div>
                    <div style={lS}>País</div>
                    <select value={formData.country} onChange={e => setFormData({ ...formData, country: e.target.value })} style={{ ...iS, cursor: "pointer" }}>
                      <option value="ES">🇪🇸 España</option>
                      <option value="AD">🇦🇩 Andorra</option>
                      <option value="FR">🇫🇷 Francia</option>
                      <option value="PT">🇵🇹 Portugal</option>
                      <option value="GB">🇬🇧 UK</option>
                      <option value="OTHER">🌍 Otro</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Terms */}
              <div style={{ fontSize: 11, color: "#475569", lineHeight: 1.6, marginBottom: 16 }}>
                Al suscribirte aceptas los <span style={{ color: "#60a5fa", cursor: "pointer" }}>Términos de Servicio</span> y la <span style={{ color: "#60a5fa", cursor: "pointer" }}>Política de Privacidad</span>. Se te cobrará €{selectedPlan.price}/mes. Puedes cancelar en cualquier momento sin penalización.
              </div>

              {/* Pay button */}
              <button onClick={handleCheckout} style={{ width: "100%", padding: "15px 0", borderRadius: 12, background: "linear-gradient(135deg,#3b82f6,#2563eb)", color: "#fff", fontSize: 16, fontWeight: 700, border: "none", cursor: "pointer", boxShadow: "0 6px 24px rgba(59,130,246,0.3)", transition: "all 0.2s", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                🔒 Pagar €{selectedPlan.price}/mes
              </button>

              <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 14 }}>
                {["🔒 SSL 256-bit", "Powered by Stripe", "PCI DSS"].map((t, i) => (
                  <span key={i} style={{ fontSize: 10, color: "#334155" }}>{t}</span>
                ))}
              </div>
            </div>

            {/* Order summary */}
            <div>
              <div style={{ ...CRD, padding: 24, position: "sticky", top: 80 }}>
                <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 14 }}>Resumen del pedido</h3>
                <div style={{ background: `${selectedPlan.color}08`, borderRadius: 10, padding: 14, border: `1px solid ${selectedPlan.color}18`, marginBottom: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                    <span style={{ fontSize: 22 }}>{selectedPlan.icon}</span>
                    <div>
                      <div style={{ fontSize: 16, fontWeight: 800 }}>Plan {selectedPlan.name}</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>Suscripción mensual</div>
                    </div>
                  </div>
                  {selectedPlan.features.slice(0, 4).map((f, i) => (
                    <div key={i} style={{ fontSize: 11, color: "#94a3b8", padding: "2px 0", display: "flex", gap: 6 }}>
                      <span style={{ color: selectedPlan.color }}>✓</span>{f}
                    </div>
                  ))}
                </div>
                <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 14 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                    <span style={{ fontSize: 13, color: "#94a3b8" }}>Plan {selectedPlan.name}</span>
                    <span style={{ fontSize: 13 }}>€{selectedPlan.price}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                    <span style={{ fontSize: 13, color: "#94a3b8" }}>Setup</span>
                    <span style={{ fontSize: 13, color: "#22c55e" }}>€0 (gratis)</span>
                  </div>
                  <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 10, marginTop: 10, display: "flex", justifyContent: "space-between" }}>
                    <span style={{ fontSize: 15, fontWeight: 700 }}>Total / mes</span>
                    <span style={{ fontSize: 22, fontWeight: 800, color: selectedPlan.color }}>€{selectedPlan.price}</span>
                  </div>
                </div>
                <div style={{ marginTop: 14, padding: "10px 12px", borderRadius: 8, background: "rgba(34,197,94,0.06)", border: "1px solid rgba(34,197,94,0.1)", fontSize: 11, color: "#22c55e", lineHeight: 1.5 }}>
                  ✓ Dashboard activo desde el día 1<br />
                  ✓ Primer informe en 30 días<br />
                  ✓ Cancela cuando quieras
                </div>
              </div>
            </div>
          </div>
        </>}

        {/* ═══ PROCESSING ═══ */}
        {view === "processing" && (
          <div style={{ textAlign: "center", padding: "80px 0", animation: "fadeUp 0.5s ease" }}>
            <div style={{ width: 80, height: 80, borderRadius: "50%", border: "3px solid rgba(59,130,246,0.1)", borderTop: "3px solid #3b82f6", animation: "spin 1s linear infinite", margin: "0 auto 24px" }} />
            <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Procesando tu pago...</h2>
            <p style={{ fontSize: 14, color: "#64748b", marginBottom: 24 }}>No cierres esta ventana</p>
            <div style={{ maxWidth: 400, margin: "0 auto" }}>
              <div style={{ height: 6, background: "rgba(255,255,255,0.05)", borderRadius: 3, overflow: "hidden", marginBottom: 12 }}>
                <div style={{ width: `${progress}%`, height: "100%", background: "linear-gradient(90deg,#3b82f6,#8b5cf6)", borderRadius: 3, transition: "width 0.5s ease", boxShadow: "0 0 12px rgba(59,130,246,0.3)" }} />
              </div>
              <div style={{ fontSize: 12, color: "#64748b" }}>
                {progress < 20 && "Validando datos de tarjeta..."}
                {progress >= 20 && progress < 40 && "Conectando con Stripe..."}
                {progress >= 40 && progress < 60 && "Procesando cobro..."}
                {progress >= 60 && progress < 80 && "Creando tu cuenta..."}
                {progress >= 80 && progress < 95 && "Configurando dashboard..."}
                {progress >= 95 && "¡Casi listo!"}
              </div>
            </div>
          </div>
        )}

        {/* ═══ SUCCESS ═══ */}
        {view === "success" && subscription && (
          <div style={{ textAlign: "center", padding: "40px 0", animation: "fadeUp 0.6s ease" }}>
            {/* Animated checkmark */}
            <div style={{ width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg,rgba(34,197,94,0.15),rgba(34,197,94,0.05))", border: "2px solid rgba(34,197,94,0.3)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 20, animation: "pulse 2s ease infinite" }}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12" style={{ strokeDasharray: 100, animation: "check 0.6s ease 0.3s forwards", strokeDashoffset: 100 }} /></svg>
            </div>
            <h2 style={{ fontSize: 28, fontWeight: 800, marginBottom: 6 }}>¡Bienvenido a SEO Flor!</h2>
            <p style={{ fontSize: 15, color: "#64748b", marginBottom: 28 }}>Tu suscripción al plan <strong style={{ color: selectedPlan.color }}>{selectedPlan.name}</strong> está activa</p>

            <div style={{ ...CRD, padding: 24, maxWidth: 500, margin: "0 auto 20px", textAlign: "left" }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Detalles de tu suscripción</h3>
              {[
                { l: "Plan", v: selectedPlan.name, c: selectedPlan.color },
                { l: "Precio", v: `€${selectedPlan.price}/mes`, c: "#e2e8f0" },
                { l: "ID Suscripción", v: subscription.id, c: "#60a5fa" },
                { l: "Empresa", v: subscription.customer.company, c: "#e2e8f0" },
                { l: "Email", v: subscription.customer.email, c: "#e2e8f0" },
                { l: "Tarjeta", v: `${subscription.card.brand} ****${subscription.card.last4}`, c: "#e2e8f0" },
                { l: "Período", v: `${subscription.currentPeriodStart} — ${subscription.currentPeriodEnd}`, c: "#e2e8f0" },
                { l: "Estado", v: "✅ Activa", c: "#22c55e" },
              ].map((r, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.03)" }}>
                  <span style={{ fontSize: 12, color: "#64748b" }}>{r.l}</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: r.c }}>{r.v}</span>
                </div>
              ))}
            </div>

            <div style={{ ...CRD, padding: 18, maxWidth: 500, margin: "0 auto 24px", background: "rgba(59,130,246,0.04)", borderColor: "rgba(59,130,246,0.12)" }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: "#60a5fa" }}>📧 Hemos enviado a {subscription.customer.email}:</div>
              <div style={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.7 }}>
                ✓ Confirmación de pago y factura<br />
                ✓ Credenciales de acceso al dashboard<br />
                ✓ Guía de inicio rápido
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <button onClick={() => { setView("manage"); }} style={{ padding: "12px 28px", borderRadius: 10, background: "linear-gradient(135deg,#3b82f6,#2563eb)", color: "#fff", fontSize: 14, fontWeight: 700, border: "none", cursor: "pointer", boxShadow: "0 4px 16px rgba(59,130,246,0.25)" }}>📊 Ir a mi Dashboard</button>
              <button onClick={() => setView("manage")} style={{ padding: "12px 28px", borderRadius: 10, background: "rgba(255,255,255,0.04)", color: "#e2e8f0", fontSize: 14, fontWeight: 700, border: "1px solid rgba(255,255,255,0.08)", cursor: "pointer" }}>💳 Ver mi suscripción</button>
            </div>
          </div>
        )}

        {/* ═══ SUBSCRIPTION MANAGEMENT ═══ */}
        {view === "manage" && subscription && <>
          <button onClick={() => setView("plans")} style={{ background: "none", border: "none", color: "#60a5fa", cursor: "pointer", fontSize: 12, fontWeight: 600, padding: 0, marginBottom: 16 }}>← Volver</button>
          <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 18 }}>Mi Suscripción</h1>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 18 }}>
            <div style={{ ...CRD, padding: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>Plan actual</div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                <span style={{ fontSize: 28 }}>{selectedPlan.icon}</span>
                <div>
                  <div style={{ fontSize: 20, fontWeight: 800, color: selectedPlan.color }}>{selectedPlan.name}</div>
                  <div style={{ fontSize: 13, color: "#64748b" }}>€{selectedPlan.price}/mes</div>
                </div>
                <span style={{ marginLeft: "auto", padding: "4px 12px", borderRadius: 16, background: "rgba(34,197,94,0.1)", color: "#22c55e", fontSize: 11, fontWeight: 700 }}>Activa</span>
              </div>
              {selectedPlan.features.map((f, i) => (
                <div key={i} style={{ fontSize: 12, color: "#94a3b8", padding: "2px 0", display: "flex", gap: 5 }}>
                  <span style={{ color: selectedPlan.color }}>✓</span>{f}
                </div>
              ))}
              <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
                <button onClick={() => fire("✓ Redirigiendo a cambio de plan...")} style={{ padding: "8px 16px", borderRadius: 8, background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.12)", color: "#60a5fa", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>⬆ Cambiar plan</button>
                <button onClick={() => setShowCancel(true)} style={{ padding: "8px 16px", borderRadius: 8, background: "rgba(239,68,68,0.04)", border: "1px solid rgba(239,68,68,0.08)", color: "#ef4444", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Cancelar suscripción</button>
              </div>
            </div>
            <div style={{ ...CRD, padding: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>Método de pago</div>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16, padding: "12px 14px", borderRadius: 10, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.05)" }}>
                <span style={{ fontSize: 20 }}>💳</span>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{subscription.card.brand} ****{subscription.card.last4}</div>
                  <div style={{ fontSize: 11, color: "#475569" }}>Expira {formData.expiry || "12 / 28"}</div>
                </div>
                <button onClick={() => fire("✓ Abriendo formulario de tarjeta...")} style={{ marginLeft: "auto", padding: "5px 12px", borderRadius: 6, background: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.1)", color: "#60a5fa", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>Cambiar</button>
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 10 }}>Datos de facturación</div>
              {[
                { l: "Nombre", v: subscription.customer.name },
                { l: "Email", v: subscription.customer.email },
                { l: "Empresa", v: subscription.customer.company },
                { l: "País", v: formData.country === "ES" ? "España" : formData.country === "AD" ? "Andorra" : formData.country },
              ].map((r, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", borderBottom: "1px solid rgba(255,255,255,0.02)", fontSize: 12 }}>
                  <span style={{ color: "#64748b" }}>{r.l}</span><span>{r.v}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Invoices */}
          <div style={{ ...CRD, padding: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>Facturas</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 0", borderBottom: "1px solid rgba(255,255,255,0.03)" }}>
              <span style={{ flex: 1, fontSize: 12 }}>Factura {subscription.invoices[0].id}</span>
              <span style={{ fontSize: 12, color: "#64748b" }}>{subscription.invoices[0].date}</span>
              <span style={{ fontSize: 13, fontWeight: 700 }}>€{subscription.invoices[0].amount}</span>
              <span style={{ padding: "2px 10px", borderRadius: 10, background: "rgba(34,197,94,0.08)", color: "#22c55e", fontSize: 10, fontWeight: 600 }}>Pagada</span>
              <button onClick={() => fire("✓ Descargando factura PDF...")} style={{ padding: "4px 10px", borderRadius: 5, background: "rgba(59,130,246,0.06)", border: "1px solid rgba(59,130,246,0.1)", color: "#60a5fa", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>📥 PDF</button>
            </div>
            <div style={{ fontSize: 11, color: "#475569", marginTop: 8 }}>Próximo cobro: <strong style={{ color: "#e2e8f0" }}>{subscription.currentPeriodEnd}</strong> · €{selectedPlan.price}</div>
          </div>

          {/* Cancel modal */}
          {showCancel && <div style={{ position: "fixed", inset: 0, zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.7)", backdropFilter: "blur(6px)" }} onClick={() => setShowCancel(false)}>
            <div onClick={e => e.stopPropagation()} style={{ background: "#0a0f1e", borderRadius: 16, padding: 28, border: "1px solid rgba(239,68,68,0.15)", width: 420, boxShadow: "0 20px 50px rgba(0,0,0,0.5)" }}>
              <h3 style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>⚠️ Cancelar suscripción</h3>
              <p style={{ fontSize: 13, color: "#94a3b8", marginBottom: 16, lineHeight: 1.6 }}>¿Seguro que quieres cancelar tu plan {selectedPlan.name}? Tu dashboard seguirá activo hasta el {subscription.currentPeriodEnd}. No se realizarán más cobros.</p>
              <div style={{ display: "flex", gap: 8 }}>
                <button onClick={() => { setSubscription({ ...subscription, status: "cancelled" }); setShowCancel(false); fire("✓ Suscripción cancelada. Activa hasta " + subscription.currentPeriodEnd); }} style={{ flex: 1, padding: "11px 0", borderRadius: 10, background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.2)", color: "#ef4444", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Sí, cancelar</button>
                <button onClick={() => setShowCancel(false)} style={{ flex: 1, padding: "11px 0", borderRadius: 10, background: "linear-gradient(135deg,#3b82f6,#2563eb)", color: "#fff", fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer" }}>No, mantener</button>
              </div>
            </div>
          </div>}
        </>}
      </div>
    </div>
  );
}
